import { useContext } from 'react'

import { CentrifugeContext } from '../../Centrifuge.context'

export function useCentrifugeContext() {
  const context = useContext(CentrifugeContext)

  if (!context) {
    throw new Error(
      'useCentrifugeContext must be used within CentrifugeProvider'
    )
  }

  return context
}
